import { DELETE_API, GET_API, POST_API } from "../../Functionalities/APIs";
import { csvLine } from "../Settlements/csv";

const LIST_URL = "/accounts/salary/payments/";
const RECORD_URL = "/accounts/settlement/riders/payments/";

export const PAYMENT_MODES = [
  ["CASH", "Cash"],
  ["UPI", "UPI"],
  ["BANK_TRANSFER", "Bank transfer"],
  ["CHEQUE", "Cheque"],
  ["OTHER", "Other"],
];

export const todayInIndia = (now = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(now);

export const blankPayment = () => ({
  amount: "", paid_on: todayInIndia(), mode: "CASH", account: "", reference: "", collected_by: "", notes: "",
});

export const paymentsQuery = ({ riderId, range, limit = 200, offset = 0 }) =>
  [riderId && `rider_id=${riderId}`, `limit=${limit}`, offset && `offset=${offset}`, range && `from=${range.from}&to=${range.to}`]
    .filter(Boolean)
    .join("&");

const bodyOf = (result) => (result && result.data) || {};

export const fetchPayments = async (options) => {
  const body = bodyOf(await GET_API("", paymentsQuery(options), LIST_URL));
  return body.Status === true
    ? { rows: body.results, summary: body.summary, count: body.count, total: body.total }
    : { rows: [], summary: null, count: 0, total: 0, error: body.Error || "Could not load the payments" };
};

export const fetchAllPayments = async (range) => {
  const rows = [];
  for (let offset = 0; ; offset += 200) {
    const page = await fetchPayments({ range, limit: 200, offset });
    rows.push(...page.rows);
    if (page.rows.length < 200 || rows.length >= page.count) return rows;
  }
};

export const paymentsCsv = (rows) =>
  [
    "Paid on,Rider ID,Rider,Amount,Mode,To account,Reference,Collected by,Note,Recorded by",
    ...rows.map((row) =>
      csvLine([
        row.paid_on, Number(row.rider.id), row.rider.name, Number(row.amount), row.mode_label, row.account, row.reference,
        row.collected_by, row.notes, row.recorded_by,
      ])
    ),
  ].join("\n");

export const recordPayment = async (riderId, values) => {
  const data = new FormData();
  data.append("rider_id", riderId);
  Object.entries(values).forEach(([key, value]) => data.append(key, String(value ?? "").trim()));
  return bodyOf(await POST_API(data, "", RECORD_URL));
};

export const deletePayment = async (paymentId) => bodyOf(await DELETE_API("", "", `${RECORD_URL}${paymentId}/`));
